__turbopack_context__.v({
  "closeButtonContainer": "styles-module__ysRTsG__closeButtonContainer",
  "description": "styles-module__ysRTsG__description",
  "modalContainer": "styles-module__ysRTsG__modalContainer",
  "modalContent": "styles-module__ysRTsG__modalContent",
  "title": "styles-module__ysRTsG__title",
});
